import { styled } from '@linaria/react';

export const CloseIcon = styled.div`
  position: relative;
  width: 13px;
  height: 13px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 13px;
    height: 2px;
    background: #c0c0c0;
    transform-origin: center;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;
